import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DetailedFlowHistory, FlowHistory } from '../../common/models/flow.dto';
import { Observable } from 'rxjs';

@Injectable()
export class FlowHistoryService {
    readonly API_ROUTE = '/api/flowhistory';

    constructor(
        public _httpClient: HttpClient,
    ) { }

    getDetailedFlowInstanceHistory(id: string): Observable<DetailedFlowHistory[]> {
        return this._httpClient.get<DetailedFlowHistory[]>(`${this.API_ROUTE}/${id}`);
    }

    saveHistory(history: FlowHistory): Observable<any> {
        return this._httpClient.post(`${this.API_ROUTE}/saveHistory`, history);
    }
}
